'use strict';

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const GroupBasedDataService=require('../../../dist-es6/client/services/groupBasedDataService');let

LiveGroupBasedDataService=class LiveGroupBasedDataService extends GroupBasedDataService{
constructor($timeout,dateService,statisticalDisplayDataService,groupTreeService,displaySettingsService){
super($timeout,groupTreeService);
this._dateService=dateService;
this._statisticalDisplayDataService=statisticalDisplayDataService;
this._displaySettingsService=displaySettingsService;

this._lastFetchTime=void 0;
this._currentlyLoadedGroupIds=new Set;
}

get lastFetchTime(){
return this._lastFetchTime;
}

get estimatesAsOfTime(){
return this._estimatesAsOfTime;
}

get currentlyLoadedGroupIds(){
return this._currentlyLoadedGroupIds;
}

_clearCache(){
super._clearCache();
this._lastFetchTime=void 0;
}

_updateCurrentlyLoadedGroupIds(latestGroupTree,selectedGroupId){
const nonOrganizationGroupTree={children:latestGroupTree.slice(1)};

if(selectedGroupId===null){
const currentlyLoadedGroupIds=_getAllGroupIdsFrom(nonOrganizationGroupTree);
this._currentlyLoadedGroupIds=new Set(_.compact(currentlyLoadedGroupIds).concat(null));
}else{
const foundGroupInTree=_findGroupWithId(nonOrganizationGroupTree,selectedGroupId);
const currentlyLoadedGroupIds=_getAllGroupIdsFrom(foundGroupInTree);
this._currentlyLoadedGroupIds=new Set(_.compact(currentlyLoadedGroupIds));
}
}

async _fetchLatestData(){
throw new Error('Abstract! Implement _fetchLatestData on subclass.');
}

async _update(cancellationToken,...args){
const groupId=tryGet(this._displaySettingsService,'stickySettings').
then(stickySettings=>stickySettings.get('selectedGroupId')).
otherwise(null);

const latestData=await this._fetchLatestData(...args);

if(cancellationToken.cancelled){
return;
}

this._updateCurrentlyLoadedGroupIds(latestData.groupTree,groupId);

this._groupTreeService.updateOrgLevelGroupVisibilitySettings({
hideAllGroupsByDefault:latestData.hideAllGroupsByDefault});


await this._$timeout(()=>{
this.groupTree=latestData.groupTree;
this._lastFetchTime=this._dateService.now();
this._estimatesAsOfTime=latestData.estimatesAsOfTime;
});
}};


const _findGroupWithId=(group,id)=>{
if(group.id===id){
return group;
}

for(const subGroup of group.children){
const foundGroup=_findGroupWithId(subGroup,id);
if(_.exists(foundGroup)){
return foundGroup;
}
}
};

const _getAllGroupIdsFrom=group=>{
if(!_.exists(group)){
return;
}

return[].concat(group.id,...group.children.map(g=>_getAllGroupIdsFrom(g)));
};


module.exports=LiveGroupBasedDataService;
//# sourceMappingURL=liveGroupBasedDataService.js.map
